<template>
  <div style="position: relative;">
    <iframe frameborder="0" style="width: 500px; height: 400px; border:1" v-bind:src="getUrl" allowfullscreen></iframe>
    <v-btn class="ma-0 pa-0" style="position: absolute; z-index: 9999; left: auto; right: 2px; top: 2px; bottom: auto;" tile small color="red" icon @click="closeThis()">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </div>
</template>
<style>

</style>
<style scoped>
</style>

<script>
export default {
  name: "myMap",
  data() {
    return {
      place: "",
      latlng: ""
    };
  },
  methods: {
    closeThis() {
      this.dialog.close()
    },
  },
  computed: {
    getUrl() {
      return this.latlng ? "https://www.google.com/maps/embed/v1/place?key=AIzaSyDPvAYjsAsaxJ0PQq7F7Ic-sudbJw3P9io&language=bg&q=@" + this.latlng.lat + "," + this.latlng.lng : "https://www.google.com/maps/embed/v1/place?key=AIzaSyDPvAYjsAsaxJ0PQq7F7Ic-sudbJw3P9io&language=bg&q=" + this.place;
    }
  },
  created() {
    this.data = this.dialog.data;
    if (this.dialog.options) {
      this.place = this.dialog.options.address;
      this.latlng = this.dialog.options.latlng;
    }
  }

};
</script>